export const EB_DISCOUNT_PERCENT = 50;

export function getEbPrice(mrp: number, discountPercent = EB_DISCOUNT_PERCENT): number {
  return Math.round(mrp * (1 - discountPercent / 100));
}

export type MarketplaceCountryCode = "IN" | "AE";

export function formatMarketplacePrice(
  amount: number,
  country: MarketplaceCountryCode = "IN"
): string {
  if (country === "AE") {
    return `AED ${amount.toLocaleString("en-AE")}`;
  }
  return `₹${amount.toLocaleString("en-IN")}`;
}

export const VENDOR_SERVICE_PRICING: Record<string, { mrp: number; priceUnit?: string }[]> = {
  "visit-health": [
    { mrp: 1200, priceUnit: "visit" },
    { mrp: 599, priceUnit: "consult" },
    { mrp: 399, priceUnit: "month" },
    { mrp: 999, priceUnit: "month" },
    { mrp: 1999, priceUnit: "package" },
    { mrp: 149, priceUnit: "order" },
    { mrp: 1500, priceUnit: "visit" },
    { mrp: 499, priceUnit: "year" },
  ],
  "benefit-care-wellness": [
    { mrp: 299, priceUnit: "month" },
    { mrp: 499, priceUnit: "month" },
    { mrp: 399, priceUnit: "program" },
    { mrp: 199, priceUnit: "month" },
    { mrp: 349, priceUnit: "month" },
    { mrp: 299, priceUnit: "month" },
  ],
  "doctor-online-bee": [
    { mrp: 799, priceUnit: "consult" },
    { mrp: 899, priceUnit: "consult" },
    { mrp: 899, priceUnit: "consult" },
    { mrp: 799, priceUnit: "consult" },
    { mrp: 1299, priceUnit: "consult" },
    { mrp: 199, priceUnit: "month" },
  ],
  "quick-garage": [
    { mrp: 3499, priceUnit: "service" },
    { mrp: 1499, priceUnit: "service" },
    { mrp: 3999, priceUnit: "battery" },
    { mrp: 999, priceUnit: "service" },
    { mrp: 8999, priceUnit: "job" },
    { mrp: 1499, priceUnit: "session" },
    { mrp: 999, priceUnit: "year" },
  ],
  "cult-fit": [
    { mrp: 15999, priceUnit: "year" },
    { mrp: 499, priceUnit: "class" },
    { mrp: 999, priceUnit: "month" },
    { mrp: 1999, priceUnit: "session" },
    { mrp: 799, priceUnit: "session" },
    { mrp: 299, priceUnit: "class" },
  ],
  practo: [
    { mrp: 799, priceUnit: "visit" },
    { mrp: 599, priceUnit: "consult" },
    { mrp: 1299, priceUnit: "package" },
    { mrp: 299, priceUnit: "year" },
    { mrp: 99, priceUnit: "order" },
    { mrp: 199, priceUnit: "month" },
  ],
  yourdost: [
    { mrp: 1499, priceUnit: "session" },
    { mrp: 499, priceUnit: "month" },
    { mrp: 999, priceUnit: "month" },
    { mrp: 1299, priceUnit: "session" },
    { mrp: 899, priceUnit: "month" },
    { mrp: 699, priceUnit: "month" },
  ],
  healthians: [
    { mrp: 4999, priceUnit: "package" },
    { mrp: 299, priceUnit: "visit" },
    { mrp: 899, priceUnit: "test" },
    { mrp: 799, priceUnit: "test" },
    { mrp: 1499, priceUnit: "panel" },
    { mrp: 3499, priceUnit: "package" },
  ],
  "go-mechanic": [
    { mrp: 2999, priceUnit: "service" },
    { mrp: 499, priceUnit: "trip" },
    { mrp: 1999, priceUnit: "service" },
    { mrp: 7999, priceUnit: "job" },
    { mrp: 4499, priceUnit: "battery" },
    { mrp: 999, priceUnit: "check" },
  ],
  lenskart: [
    { mrp: 499, priceUnit: "test" },
    { mrp: 2999, priceUnit: "pair" },
    { mrp: 1499, priceUnit: "box" },
    { mrp: 199, priceUnit: "trial" },
    { mrp: 1999, priceUnit: "pair" },
    { mrp: 999, priceUnit: "order" },
  ],
  "urban-company": [
    { mrp: 999, priceUnit: "session" },
    { mrp: 1999, priceUnit: "session" },
    { mrp: 799, priceUnit: "visit" },
    { mrp: 1499, priceUnit: "session" },
    { mrp: 1299, priceUnit: "visit" },
    { mrp: 1499, priceUnit: "visit" },
  ],
  "paw-insurance": [
    { mrp: 8999, priceUnit: "year" },
    { mrp: 499, priceUnit: "consult" },
    { mrp: 5999, priceUnit: "year" },
    { mrp: 7499, priceUnit: "year" },
    { mrp: 1999, priceUnit: "year" },
  ],
};
